<template>
  <div
    v-if="show"
    class="items-start w-full px-4 py-4 text-sm rounded-lg md_justify-between"
    :class="[bannerType, `theme-${theme}`]"
    data-testid="v-message-banner"
  >
    <div class="flex items-center">
      <slot name="icon">
        <DynamicHeroIcon :key="iconType" class="flex-shrink-0 w-6 mr-4" :icon-name="iconType" icon-style="solid" />
      </slot>

      <div class="items-center flex-grow text-sm text-gray-900">
        <slot />
      </div>
    </div>

    <div v-if="!hideDismiss" class="flex-shrink-0 text-gray-900 cta">
      <slot name="dismiss">
        <XIcon class="w-4 cursor-pointer" @click="$emit('dismiss')" />
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
export type BannerType = 'success' | 'danger' | 'info' | 'warning' | 'private'
</script>

<script lang="ts" setup>
import type { PropType } from 'vue'
import XIcon from '@/components/icons/x.svg'

const props = defineProps({
  bannerType: {
    type: String as PropType<BannerType>,
    default: 'info',
  },
  show: {
    type: Boolean,
    default: false,
  },
  hideDismiss: {
    type: [Boolean, String],
    default: false,
  },
  theme: {
    type: String as PropType<'default' | 'mobile' | 'settings'>,
    default: 'default',
  },
})

const iconType = computed(
  () =>
    ({
      success: 'CheckCircleIcon',
      danger: 'XCircleIcon',
      warning: 'ExclamationTriangleIcon',
      info: 'InformationCircleIcon',
      private: 'ShieldExclamationIcon',
    }[props.bannerType])
)

defineEmits(['dismiss'])
</script>

<style lang="stylus" scoped>
.warning
  @apply bg-gold-100 text-gold-50

.private
  @apply bg-gold-100 text-black

.danger
  @apply bg-red-100 text-red-800

.success
  @apply bg-copper-50 text-copper-700

.info
  @apply bg-blue-100 text-blue-700

.theme-default
  @apply md_flex

.theme-mobile
  @apply flex flex-col

  .cta
    @apply w-full mt-3

.theme-settings
  @apply md_flex-none

  .cta
    @apply md_ml-8 md_w-40 md_mt-1
</style>
